export const getInputStyles = (readOnly?: boolean, hasError?: boolean, isOverridden?: boolean) => {
  let borderColor = 'border-slate-300';
  let bgColor = readOnly ? 'bg-slate-100' : 'bg-white';
  let focusStyles = 'focus:border-teal-500 focus:ring-1 focus:ring-teal-500/20';
  let textColor = readOnly ? 'text-slate-500' : 'text-slate-900';
  
  if (hasError) {
    if (isOverridden) {
      // Warning / Overridden state
      borderColor = 'border-amber-400';
      bgColor = readOnly ? 'bg-amber-50/50' : 'bg-amber-50';
      focusStyles = 'focus:border-amber-500 focus:ring-1 focus:ring-amber-500/20';
    } else {
      // Error state
      borderColor = 'border-red-300';
      bgColor = readOnly ? 'bg-red-50/50' : 'bg-red-50';
      focusStyles = 'focus:border-red-500 focus:ring-1 focus:ring-red-500/20';
    }
  } else if (readOnly) {
      borderColor = 'border-slate-200';
  }

  const baseStyles = 'w-full px-3 py-2 border rounded-lg shadow-sm text-sm transition-all placeholder-slate-400';
  const stateStyles = readOnly ? 'cursor-not-allowed' : `focus:outline-none ${focusStyles}`;

  return `${baseStyles} ${borderColor} ${bgColor} ${textColor} ${stateStyles}`;
};